import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { cn } from "helpers/cn";
import EmptyIcon from "images/empty.svg?react";

const Empty = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={cn("mx-2 flex flex-col items-center gap-2 text-center", className)}
    data-slot="empty"
    {...props}
  />
);

const EmptyHeader = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={cn("flex flex-col items-center gap-2", className)}
    data-slot="empty-header"
    {...props}
  />
);

const emptyMediaVariants = cva(
  "flex shrink-0 items-center justify-center [&>img]:h-full [&>svg]:h-full",
  {
    variants: {
      size: {
        default: "h-25",
        large: "h-32"
      }
    },
    defaultVariants: { size: "default" }
  }
);

type EmptyMediaProps = ComponentProps<"div"> & VariantProps<typeof emptyMediaVariants>;

const EmptyMedia = ({
  className,
  size,
  children = <EmptyIcon />,
  ...props
}: EmptyMediaProps) => (
  <div
    className={cn(emptyMediaVariants({ size }), className)}
    data-slot="empty-icon"
    {...props}
  >
    {children}
  </div>
);

const EmptyTitle = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={cn("font-heading text-heading-sm text-foreground", className)}
    data-slot="empty-title"
    {...props}
  />
);

const EmptyDescription = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={cn("text-body-small text-secondary", className)}
    data-slot="empty-description"
    {...props}
  />
);

const EmptyContent = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={cn("flex flex-col items-center", className)}
    data-slot="empty-content"
    {...props}
  />
);

export {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  emptyMediaVariants
};
